<div class="wrapper">
    <app-dialog-title
        class="header"
        [title]="'pages.services-state.dialogs.services-statuses-dialog.title' | translate"
        (close)="close()"
    ></app-dialog-title>
    
    <mat-dialog-content>
        <div class="section-statuses-list">
          <section class="loading" *ngIf="loading">
            <mat-progress-spinner 
              mode="indeterminate" 
              diameter="20"
            ></mat-progress-spinner>
          </section>
          <ng-container *ngIf="!loading">
            <app-bciti-category-input
              *ngFor="let status of statuses$ | async"
              [category]="status"
              [colors]="colors"
              [characterLimit]="14"
              [disabled]="disableActions"
              [propertyLabelInput]="propertyLabelInput.STATUS"
              [textInputHint]="null"
              (onSave)="handleSave($event)"
              (onDelete)="deleteStatus($event)"
              (onFormOpen)="closeAllOtherForms($event)"
              (currentState)="toggleAddButtonDisplay($event)"
            ></app-bciti-category-input>
          </ng-container>
          </div>
          <div class="section-add-status" [class.creating]="creating">
            <button 
              *ngIf="toggleAddButton" 
              class="bciti-button bciti-button--blue"
              [disabled]="disableActions"
              (click)="startCreating()"
            >{{ 'common.add' | translate }}</button>
            <app-bciti-category-input
              *ngIf="creating"
              [characterLimit]="14"
              [colors]="colors"
              [disabled]="disableActions"
              [propertyLabelInput]="propertyLabelInput.STATUS"
              [textInputHint]="null"
              (onSave)="handleSave($event)"
              (cancelCreate)="handleCancelCreate()"
            ></app-bciti-category-input>
          </div>
    </mat-dialog-content>
</div>
